import {
    NavigationFrameLayoutEnum,
    NavigationLayoutTypeEnum,
    NavigationVisualStyleEnum,
} from "@/scripts/common/enums.js";

export default {
    computed: {
        layoutClass() {
            const layoutType = this.navigation?.layout?.layoutType;
            const alignment = this.navigation?.layout?.alignment;
            if (layoutType === NavigationLayoutTypeEnum.SIMPLE) {
                const align = this.toKebab(alignment) || "left";
                return `simple-${align}`;
            }
            if (layoutType === NavigationLayoutTypeEnum.SIMPLE_WITH_LOGO) return "simple-with-logo";
            if (layoutType === NavigationLayoutTypeEnum.SIDES) return "sides";
            if (layoutType === NavigationLayoutTypeEnum.SIDES_WITH_CTA) return "sides-with-cta";
            if (layoutType === NavigationLayoutTypeEnum.SPLIT_NAVIGATION) return "split-navigation";
            if (layoutType === NavigationLayoutTypeEnum.SPLIT_LOGO) return "split-logo";
            if (layoutType === NavigationLayoutTypeEnum.CENTERED) return "middle";
            if (layoutType === NavigationLayoutTypeEnum.SIDEBAR) {
                const align = this.toKebab(alignment) || "left";
                return `simple-${align}`;
            }
            return "simple-left";
        },
        styleClass() {
            if (this.navigation?.layout?.visualStyle === NavigationVisualStyleEnum.FRAMED) return "framed";
            if (this.navigation?.layout?.visualStyle === NavigationVisualStyleEnum.FORWARD_SLASH) return "forward-slash";
            if (this.navigation?.layout?.visualStyle === NavigationVisualStyleEnum.LINE_BOTH_SIDES) return "line-middle";
            if (this.navigation?.layout?.visualStyle === NavigationVisualStyleEnum.SIMPLE) return "simple";
            return "simple";
        },
        frameLayoutClass() {
            if (this.navigation?.layout?.visualStyle !== NavigationVisualStyleEnum.FRAMED) return null;
            const isCentered = this.navigation?.layout?.frameLayout === NavigationFrameLayoutEnum.CENTERED;
            const isExtraWide = this.$store?.state?.portfolio?.templateSettings?.siteMargin === "EXTRA_WIDE";

            return isCentered && !isExtraWide
                ? "framed-centered"
                : "framed-full-width";
        },
        buttonStyleClass() {
            const menu = this.navigation?.menu || {};
            if (!menu?.style) return ["simple"];

            const classes = [this.toKebab(menu.style)];
            if (menu.linkHoverEffect) {
                classes.push(`hover-${this.toKebab(menu.linkHoverEffect)}`);
            }
            if (menu.style === "Underlined") {
                classes.push(
                    `size-${this.toKebab(menu.underlinedSize)}`,
                    `weight-${this.toKebab(menu.underlinedWeight)}`
                );
            }
            if (menu.style === "Framed") {
                classes.push(this.toKebab(menu.boxedShape), this.toKebab(menu.boxedWeight));
            }

            return classes.filter(Boolean);
        },
        showLines() {
            return this.navigation?.layout?.visualStyle === NavigationVisualStyleEnum.LINE_BOTH_SIDES;
        },
    },
    methods: {
        toKebab(value) {
            if (!value) return null;
            return value
                .toString()
                .replace(/([a-z])([A-Z])/g, "$1-$2")
                .replace(/_/g, "-")
                .toLowerCase();
        },
        showSeparator(index) {
            return index > 0 && this.styleClass === "forward-slash";
        },
    },
};
